
import React from "react";

const Header = () => {

    console.log('render Header')

    return (
        <span className="navbar-brand col-sm-3 col-md-2 mr-0">
            OMERO.parade
        </span>
    );
};

export default Header;
